import React, { useEffect, useRef, useState } from 'react'
import { checkAddPermission, checkDeletePermission, checkEditPermission, fetchBarcodes, fetchBrand, fetchBrandFilterV2, fetchCategoryData, fetchCategoryDataFilterV2, fetchOriginData, fetchOriginDataFilterV2, fetchPaCodes, fetchPicImportDataFilterV2, fetchPicSalesDataFilterV2, fetchProductGroupVarietiesFilterData, filteredCategories, handleExportFilePrepackProduct, handleImportClickFile, setupEditFormData, TableFooter } from '../../../Utils/helper'
import { useSelector } from 'react-redux';
import Import from '../../../Utils/import';
import { getApi } from '../../../Services/apiService';
import DeleteModal from '../../../Utils/deleteModal';
import { DependentMultiSelectDropdown } from '../../../Utils/multiSelectDropdown';
import EditPrepackProduct from './editPrepackProduct';
import dayjs from 'dayjs';
import Select from 'react-select';
function PrepackProduct() {
  const dropdownRef = useRef()
  const [methodType, setMethodType] = useState('');
  const { data } = useSelector((state) => state.roleData);
  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importErrors, setImportErrors] = useState({
    file: '',
    general: ''
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [filterDatas, setFilterData] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [prepackProducts, setPrepackProducts] = useState([])
  const [prepackProductToDelete, setPrepackProductToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productToEdit, setProductToEdit] = useState(null);
  const [selectedBarcode, setSelectedBarcode] = useState([])
  const [selectedPrepackProductIds, setSelectedPrepackProductIds] = useState([])
  const [formData, setFormData] = useState({
    raw_product_id: "",
    raw_product_name_tc: "",
    raw_product_code: "",
    finished_product_id: "",
    finished_product_name_tc: "",
    finished_product_code: "",
    pa_code: "",
    barcode: "",
    convert_type: "",
    prepack_type: "",
    estimate_shrinkage: "",
    process_day: "",
    // convert_ratio: "",
    special_period_from: "",
    special_period_to: "",
  });
  const [formDataCopy, setFormDataCopy] = useState({
    raw_product_id: "",
    raw_product_name_tc: "",
    raw_product_code: "",
    finished_product_id: "",
    finished_product_name_tc: "",
    finished_product_code: "",
    pa_code: "",
    barcode: "",
    convert_type: "",
    prepack_type: "",
    estimate_shrinkage: "",
    process_day: "",
    // convert_ratio: "",
    special_period_from: "",
    special_period_to: "",
  });
  const [touched, setTouched] = useState({
    raw_product_id: false,
    raw_product_name_tc: false,
    raw_product_code: false,
    finished_product_id: false,
    finished_product_name_tc: false,
    finished_product_code: false,
    pa_code: false,
    barcode: false,
    convert_type: false,
    prepack_type: false,
    estimate_shrinkage: false,
    process_day: false,
    // convert_ratio: false,
    special_period_from: false,
    special_period_to: false,
  });
  const [productCategory, setProductCategory] = useState([])

  const [brandData, setBrandData] = useState([])
  const [categoryData, setCategoryData] = useState([])
  const [originData, setOriginData] = useState([])
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([])
  const [selectedOriginIds, setSelectedOriginIds] = useState([])
  const [selectedBrandName, setSelectedBrandName] = useState([])
  const [selectedProductGroupVarietyIds, setSelectedProductGroupVarietyIds] = useState([])
  const [selectedPaCode, setSelectedPaCode] = useState([])
  const [selectedConvertType, setSelectedConvertType] = useState([])
  const [selectedPrepackType, setSelectedPrepackType] = useState([])
  const [selectedPicImport, setSelectedPicImport] = useState([])
  const [selectedPicSales, setSelectedPicSales] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [pageCount, setPageCount] = useState(null)
  const [brandOpen, setBrandOpen] = useState(false)
  const [originOpen, setOriginOpen] = useState(false)
  const [categoryOpen, setCategoryOpen] = useState(false)


  useEffect(() => {
    fetchCategoryData('', setCategoryData);
    fetchOriginData('', setOriginData);
    fetchBrand('', setBrandData)
  }, [])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setBrandOpen(false)
        setCategoryOpen(false)
        setOriginOpen(false)
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const fetchProductCategoryData = async (search = '') => {
    try {

      const resp = await getApi(`/product-category?search=${encodeURIComponent(search)}&per_page=50`);
      if (resp?.success === true) {
        setProductCategory(resp?.data?.productCategories?.data || []);
      }
    } catch (error) {
    } finally {
    }
  };

  const fetchPrepackProducts = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const queryParams = new URLSearchParams();
      if (Array.isArray(selectedCategoryIds)) {
        selectedCategoryIds.forEach((id) => queryParams.append('category_ids[]', id));
      } else if (selectedCategoryIds) {
        queryParams.append('category_ids[]', selectedCategoryIds);
      }
      if (Array.isArray(selectedBrandName)) {
        selectedBrandName.forEach((id) => queryParams.append('brands[]', id));
      } else if (selectedBrandName) {
        queryParams.append('brands[]', selectedBrandName);
      }
      if (Array.isArray(selectedOriginIds)) {
        selectedOriginIds.forEach((id) => queryParams.append('origin_ids[]', id));
      } else if (selectedOriginIds) {
        queryParams.append('origin_ids[]', selectedOriginIds);
      }
      if (Array.isArray(selectedProductGroupVarietyIds)) {
        selectedProductGroupVarietyIds.forEach((id) => queryParams.append('product_ids[]', id));
      } else if (selectedProductGroupVarietyIds) {
        queryParams.append('product_ids[]', selectedProductGroupVarietyIds);
      }
      if (Array.isArray(selectedPicImport)) {
        selectedPicImport.forEach((id) => queryParams.append('pic_staff_member_import[]', id));
      } else if (selectedPicImport) {
        queryParams.append('pic_staff_member_import[]', selectedPicImport);
      }
      if (Array.isArray(selectedPicSales)) {
        selectedPicSales.forEach((id) => queryParams.append('pic_staff_member_sales[]', id));
      } else if (selectedPicSales) {
        queryParams.append('pic_staff_member_sales[]', selectedPicSales);
      }
      if (Array.isArray(selectedBarcode)) {
        selectedBarcode.forEach((id) => queryParams.append('barcodes[]', id));
      } else if (selectedBarcode) {
        queryParams.append('barcodes[]', selectedBarcode);
      }
      if (Array.isArray(selectedPaCode)) {
        selectedPaCode.forEach((id) => queryParams.append('pa_codes[]', id));
      } else if (selectedPaCode) {
        queryParams.append('pa_codes[]', selectedPaCode);
      }
      if (Array.isArray(selectedConvertType)) {
        selectedConvertType.forEach((id) => queryParams.append('convert_types[]', id));
      } else if (selectedConvertType) {
        queryParams.append('convert_types[]', selectedConvertType);
      }
      if (Array.isArray(selectedPrepackType)) {
        selectedPrepackType.forEach((id) => queryParams.append('prepack_types[]', id));
      } else if (selectedPrepackType) {
        queryParams.append('prepack_types[]', selectedPrepackType);
      }
      queryParams.append('search', searchQuery);
      queryParams.append('page', currentPage);
      queryParams.append('per_page', itemsPerPage);
      const response = await getApi(`/prepack-product?${queryParams.toString()}`);
      // setPrepackProducts(testPrepackProducts || []);
      if (response?.success) {
        setPrepackProducts(response?.data?.prepackProducts?.data || []);
        setPageCount(response?.data?.prepackProducts?.last_page || 1)
      } else {
        setError(response?.msg || 'Failed to fetch prepack product');
      }
    } catch (error) {
      setError(error.message || 'Failed to fetch prepack product');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchPrepackProducts();
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery, currentPage, itemsPerPage, selectedCategoryIds, selectedBrandName, selectedOriginIds, selectedProductGroupVarietyIds, selectedPicImport, selectedPicSales, selectedBarcode, selectedPaCode, selectedConvertType, selectedPrepackType]);

  useEffect(() => {
    if (searchTerm !== '') {
      if (categoryOpen) {
        const data = filteredCategories(searchTerm, categoryData);
        setFilterData(data?.length > 0 ? data : []);
      } else if (originOpen) {
        const data = filteredCategories(searchTerm, originData);
        setFilterData(data?.length > 0 ? data : []);
      } else if (brandOpen) {
        const data = filteredCategories(searchTerm, brandData);
        setFilterData(data?.length > 0 ? data : []);
      }
    }

  }, [searchTerm])

  useEffect(() => {
    fetchProductCategoryData()
  }, [])

  const handlePageClick = (selected) => {
    setCurrentPage(selected);
  };
  //format date from Y-m-d to Y/m/d
  const formatDate = (date) => {
    return date ? dayjs(date).format('YYYY/MM/DD') : '';
  }

  const handleSelectAllPrepackProducts = (e) => {
    setSelectedPrepackProductIds(e?.target?.checked ? prepackProducts?.map((prepackProduct) => prepackProduct?.id) : []);
  }

  const handleSelectPrepackProduct = (id) => (e) => {
    setSelectedPrepackProductIds(e?.target?.checked ? [...selectedPrepackProductIds, id] : selectedPrepackProductIds?.filter((selectedId) => selectedId !== id));
  }

  return (
    <div className="RightSideDiv product-single product-page-ui">

      {showImportModal &&

        <Import setImportFile={setImportFile} importFile={importFile} searchQuery={searchQuery} fetchData={fetchPrepackProducts} setShowImportModal={setShowImportModal} routeEnd={'/prepack-product/import'} routeexport={'/prepack-product/export'} type='Prepack Product' />
      }

      {showDeleteModal && (
        <DeleteModal setShowDeleteModal={setShowDeleteModal} todelete={prepackProductToDelete} isLoading={isLoading} setIsLoading={setIsLoading} settoDelete={setPrepackProductToDelete} fetchData={fetchPrepackProducts} route={`/prepack-product/${prepackProductToDelete?.id}`} type={'prepack product'} />
      )}



      {methodType === '' &&
        <div class="row">
          <div class="col-sm-12">
            <div className="setting-right setting-right-table table-border-show product-grouping arrival single-product pre-pack">
              <div class="table-header">
                <div className="search-card">
                  <img src={window.getPublicUrl('/assets/images/search-icon.svg')} alt="" />
                  <input
                    type="text"
                    class="search-input"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1) }}
                  />

                </div>
                <div className='header-left'>
                  <div className='header-right'>
                    {checkAddPermission(data?.permissions, 'prepack_product_list') && (
                      <button className="btn add" onClick={(e) => { e.preventDefault(); setupEditFormData(null, setFormData, setMethodType, setProductToEdit, formDataCopy); setMethodType('add') }}>Add</button>
                    )}
                  </div>
                </div>
                <div className='Prepack-type'>
                  <p>Prepack Type</p> 
                  <p>A - Quantity of raw product arrival &gt; Convert automatically</p>
                  <p>B - Quantity of daily finished products reserve &gt; Convert automatically</p>
                  <p>C - Input raw product convert(out) quantity by user manually </p>
                </div>
                <div class="table-actions">
                  {checkAddPermission(data?.permissions, 'prepack_product_list') && (
                    <button class="btn" onClick={() => handleImportClickFile(setShowImportModal, setImportFile, setImportErrors)}>
                      <img src={window.getPublicUrl('/assets/images/import.png')} alt="" />
                      Import
                    </button>
                  )}
                  <button class="btn" onClick={() => handleExportFilePrepackProduct(searchQuery, 'prepack-product.xlsx', '/prepack-product/export', selectedPrepackProductIds, selectedCategoryIds, selectedBrandName, selectedOriginIds, selectedProductGroupVarietyIds, selectedPicImport, selectedPicSales, selectedBarcode, selectedPaCode, selectedConvertType, selectedPrepackType)}>

                    <img src={window.getPublicUrl('/assets/images/export.svg')} alt="" />
                    Export
                  </button>

                </div>
              </div>
              <div className='pre-pack-products'>
                <div className=''>
                  <div className="links position-relative">
                    {/* <div className="search-card">
                      <img src={window.getPublicUrl('/assets/images/search-icon.svg')} alt="" />
                      <input
                        type="text"
                        class="search-input"
                        placeholder="Search"
                        value={searchQuery}
                        onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1) }}
                      />

                    </div> */}


                    <DependentMultiSelectDropdown
                      categoryData={[]}
                      selectedValues={selectedCategoryIds}
                      setSelectedValues={(selected) => {
                        setSelectedCategoryIds(selected);
                      }}
                      placeholder='Select Categories...'
                      noOptionsMessage='No categories available'
                      setCurrentPage={setCurrentPage}
                      fetchOptionsApi={fetchCategoryDataFilterV2}
                      dependentFilters={{
                        search_product_name_code: searchQuery,
                        // category_ids: selectedCategoryIds,
                        origin_ids: selectedOriginIds,
                        product_ids: selectedProductGroupVarietyIds,
                        brands: selectedBrandName,
                        pic_staff_member_import: selectedPicImport,
                        pic_staff_member_sales: selectedPicSales,

                        pa_codes: selectedPaCode,
                        barcodes: selectedBarcode,
                        convert_types: selectedConvertType,
                        prepack_types: selectedPrepackType,
                      }}
                    />

                    <DependentMultiSelectDropdown
                      categoryData={[]}
                      selectedValues={selectedOriginIds}
                      setSelectedValues={(selected) => {
                        setSelectedOriginIds(selected);
                      }}
                      placeholder="Select origin..."
                      noOptionsMessage='No origin available'
                      setCurrentPage={setCurrentPage}
                      fetchOptionsApi={fetchOriginDataFilterV2}
                    dependentFilters={{
                      search_product_name_code: searchQuery,
                      category_ids: selectedCategoryIds,
                      brands: selectedBrandName,
                      product_ids: selectedProductGroupVarietyIds,
                      pic_staff_member_import: selectedPicImport,
                      pic_staff_member_sales: selectedPicSales,

                      pa_codes: selectedPaCode,
                      barcodes: selectedBarcode,
                      convert_types: selectedConvertType,
                      prepack_types: selectedPrepackType,
                    }}
                    />
                    <DependentMultiSelectDropdown
                      categoryData={[]}
                      selectedValues={selectedProductGroupVarietyIds}
                      setSelectedValues={(selected) => {
                        setSelectedProductGroupVarietyIds(selected);
                      }}
                      placeholder='Select gr no...'
                      noOptionsMessage='No group available'
                      setCurrentPage={setCurrentPage}
                      fetchOptionsApi={fetchProductGroupVarietiesFilterData}
                    dependentFilters={{
                      search_product_name_code: searchQuery,
                      category_ids: selectedCategoryIds,
                      origin_ids: selectedOriginIds,
                      brands: selectedBrandName,
                      pic_staff_member_import: selectedPicImport,
                      pic_staff_member_sales: selectedPicSales,

                      pa_codes: selectedPaCode,
                      barcodes: selectedBarcode,
                      convert_types: selectedConvertType,
                      prepack_types: selectedPrepackType,
                    }}
                    />
                    <DependentMultiSelectDropdown
                      categoryData={[]}
                      selectedValues={selectedBrandName}
                      setSelectedValues={setSelectedBrandName}
                      placeholder="Select brand..."
                      noOptionsMessage='No Brand available'
                      setCurrentPage={setCurrentPage}
                      fetchOptionsApi={fetchBrandFilterV2}
                      dependentFilters={{
                        search_product_name_code: searchQuery,
                        category_ids: selectedCategoryIds,
                        origin_ids: selectedOriginIds,
                        product_ids: selectedProductGroupVarietyIds,
                        pic_staff_member_import: selectedPicImport,
                        pic_staff_member_sales: selectedPicSales,

                        pa_codes: selectedPaCode,
                        barcodes: selectedBarcode,
                        convert_types: selectedConvertType,
                        prepack_types: selectedPrepackType,
                      }}
                    />
                    <DependentMultiSelectDropdown
                      categoryData={[]}
                      selectedValues={selectedPaCode}
                      setSelectedValues={setSelectedPaCode}
                      placeholder="Select pa code..."
                      noOptionsMessage='No pa code available'
                      setCurrentPage={setCurrentPage}
                      fetchOptionsApi={fetchPaCodes}
                      dependentFilters={{
                        search_product_name_code: searchQuery,
                        category_ids: selectedCategoryIds,
                        brands: selectedBrandName,
                        product_ids: selectedProductGroupVarietyIds,
                        pic_staff_member_import: selectedPicImport,
                        pic_staff_member_sales: selectedPicSales,

                        pa_codes: selectedPaCode,
                        barcodes: selectedBarcode,
                        convert_types: selectedConvertType,
                        prepack_types: selectedPrepackType,
                    }}
                    />
                    <DependentMultiSelectDropdown
                      categoryData={[]}
                      selectedValues={selectedBarcode}
                      setSelectedValues={setSelectedBarcode}
                      placeholder="Select barcode..."
                      noOptionsMessage='No barcode available'
                      setCurrentPage={setCurrentPage}
                      fetchOptionsApi={fetchBarcodes}
                      dependentFilters={{
                        search_product_name_code: searchQuery,
                        category_ids: selectedCategoryIds,
                        brands: selectedBrandName,
                        product_ids: selectedProductGroupVarietyIds,
                        pic_staff_member_import: selectedPicImport,
                        pic_staff_member_sales: selectedPicSales,

                        pa_codes: selectedPaCode,
                        barcodes: selectedBarcode,
                        convert_types: selectedConvertType,
                        prepack_types: selectedPrepackType,
                    }}
                    />
                    <div className="multi-select-container" style={{ width: '100%', maxWidth: '400px' }}>
                      <Select
                        isMulti
                        value={selectedConvertType.map(val => ({ value: val, label: val }))}
                        onChange={(newValue) => {
                          const selectedIds = newValue ? newValue.map((opt) => opt.value) : [];
                          setSelectedConvertType(selectedIds);
                          setCurrentPage(1);
                        }}
                        options={[
                          { value: 'PC', label: 'PC' },
                          { value: 'Weight', label: 'Weight' }
                        ]}
                        placeholder="Select convert type..."
                        noOptionsMessage={() => 'No convert type available'}
                        className="custom-multiselect"
                        classNamePrefix="my-select"
                        closeMenuOnSelect={false}
                      />
                    </div>
                    <div className="multi-select-container" style={{ width: '100%', maxWidth: '400px' }}>
                      <Select
                        isMulti
                        value={selectedPrepackType.map(val => ({ value: val, label: val }))}
                        onChange={(newValue) => {
                          const selectedIds = newValue ? newValue.map((opt) => opt.value) : [];
                          setSelectedPrepackType(selectedIds);
                          setCurrentPage(1);
                        }}
                        options={[
                          { value: 'A', label: 'A' },
                          { value: 'B', label: 'B' },
                          { value: 'C', label: 'C' },
                        ]}
                        placeholder="Select prepack type..."
                        noOptionsMessage={() => 'No prepack type available'}
                        className="custom-multiselect"
                        classNamePrefix="my-select"
                        closeMenuOnSelect={false}
                      />
                    </div>
                    <DependentMultiSelectDropdown
                      categoryData={[]}
                      selectedValues={selectedPicImport}
                      setSelectedValues={setSelectedPicImport}
                      placeholder="Select pic import ..."
                      noOptionsMessage='No pic import available'
                      setCurrentPage={setCurrentPage}
                      fetchOptionsApi={fetchPicImportDataFilterV2}
                    dependentFilters={{
                      search_product_name_code: searchQuery,
                      category_ids: selectedCategoryIds,
                      origin_ids: selectedOriginIds,
                      brands: selectedBrandName,
                      product_ids: selectedProductGroupVarietyIds,
                      pic_staff_member_sales: selectedPicSales,

                      pa_codes: selectedPaCode,
                      barcodes: selectedBarcode,
                      convert_types: selectedConvertType,
                      prepack_types: selectedPrepackType,
                    }}
                    />
                    <DependentMultiSelectDropdown
                      categoryData={[]}
                      selectedValues={selectedPicSales}
                      setSelectedValues={setSelectedPicSales}
                      placeholder="Select pic sales..."
                      noOptionsMessage='No pic sales available'
                      setCurrentPage={setCurrentPage}
                      fetchOptionsApi={fetchPicSalesDataFilterV2}
                    dependentFilters={{
                      search_product_name_code: searchQuery,
                      category_ids: selectedCategoryIds,
                      origin_ids: selectedOriginIds,
                      brands: selectedBrandName,
                      product_ids: selectedProductGroupVarietyIds,
                      pic_staff_member_import: selectedPicImport,

                      pa_codes: selectedPaCode,
                      barcodes: selectedBarcode,
                      convert_types: selectedConvertType,
                      prepack_types: selectedPrepackType,
                    }}
                    />



                  </div>


                </div>
              </div>
              <div className="permission-table-inner">
                <table class="custom-table table-striped">
                  <thead>
                    <tr>
                      <th class="checkbox"><label class="checbox-cs">
                        <input type="checkbox" onChange={handleSelectAllPrepackProducts} />
                        <span class="checkmark"></span>
                      </label></th>
                      <th class="raw-product-code">Raw Product Code</th>
                      <th class="raw-product-name">Raw Product Name</th>
                      <th class="finished-product-code">Finished Product Code</th>
                      <th class="finished-product-name">Finished Product Name</th>
                      <th class="pa-code">PA Code</th>
                      <th class="barcode">Barcode</th>
                      <th class="convert-type">Convert Type</th>
                      <th class="prepack-type">Prepack Type</th>
                      <th class="estimate-shrinkage">Estimate Shrinkage%</th>
                      <th class="convert-ratio">Convert Ratio</th>
                      <th class="process-day">Process Day</th>
                      <th class="special-period-from">Special Period From</th>
                      <th class="special-period-to">Special Period To</th>
                      <th class="action">Action</th>
                    </tr>
                  </thead>
                  <tbody>


                    {isLoading ? (
                      <tr>
                        <td colSpan="12" className="text-center">
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : error ? (
                      <tr>
                        <td colSpan="12" className="text-center text-danger">{error}</td>
                      </tr>
                    ) : prepackProducts?.length === 0 ? (
                      <tr>
                        <td colSpan="12" className="text-center">No prepack products found</td>
                      </tr>
                    ) : (
                      prepackProducts?.length > 0 && prepackProducts?.map((prepackProduct, index) => (
                        <tr key={index}>
                          <td class="checkbox">
                            <label class="checbox-cs">
                              <input type="checkbox" onChange={handleSelectPrepackProduct(prepackProduct?.id)} checked={selectedPrepackProductIds?.includes(prepackProduct?.id)} />
                              <span class="checkmark"></span>
                            </label></td>
                          <td class="raw-product-code">{prepackProduct?.raw_product_code || '-'}</td>
                          <td class="raw-product-name">{prepackProduct?.raw_product_name_tc || '-'}</td>
                          <td class="finished-product-code">{prepackProduct?.finished_product_code || '-'}</td>
                          <td class="finished-product-name">{prepackProduct?.finished_product_name_tc || '-'}</td>
                          <td class="pa-code">{prepackProduct?.pa_code || '-'}</td>
                          <td class="barcode">{prepackProduct?.barcode || '-'}</td>
                          <td class="convert-type">{prepackProduct?.convert_type || '-'}</td>
                          <td class="prepack-type">{prepackProduct?.prepack_type || '-'}</td>
                          <td class="estimate-shrinkage">
                            {prepackProduct?.estimate_shrinkage ? Number(prepackProduct.estimate_shrinkage).toFixed(1) : '-'}%
                          </td>
                          <td class="convert-ratio">{prepackProduct?.convert_ratio || '-'}</td>
                          <td class="process-day">{prepackProduct?.process_day ?? '-'}</td>
                          <td class="special-period-from">{formatDate(prepackProduct?.special_period_from) || '-'}</td>
                          <td class="special-period-to">{formatDate(prepackProduct?.special_period_to) || '-'}</td>
                          <td class="action action-cs">

                            <div class="dropdown">

                              <button class=" dropdown-toggle action-btn" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> <img src={window.getPublicUrl('/assets/images/dots-icon.svg')} alt="" /></button>

                              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li>
                                  <div
                                    className='dropdown-item'
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => { e.preventDefault(); setProductToEdit(prepackProduct); setMethodType('view'); }}
                                  >
                                    <span>View</span>
                                  </div>
                                  {checkEditPermission(data?.permissions, 'prepack_product_list') && (
                                    <div
                                      className='dropdown-item'
                                      style={{ cursor: 'pointer' }}
                                      onClick={(e) => { e.preventDefault(); setProductToEdit(prepackProduct); setMethodType('edit'); }}
                                    >
                                      <span>Edit</span>
                                    </div>
                                  )}
                                  {checkAddPermission(data?.permissions, 'prepack_product_list') && (
                                    <div
                                      className='dropdown-item'
                                      style={{ cursor: 'pointer' }}
                                      onClick={(e) => { e.preventDefault(); setProductToEdit(prepackProduct); setMethodType('clone'); }}
                                    >
                                      <span>Clone</span>
                                    </div>
                                  )}
                                  {checkDeletePermission(data?.permissions, 'prepack_product_list') && (
                                    <div
                                      className='dropdown-item'
                                      style={{ cursor: 'pointer' }}
                                      onClick={(e) => { e.preventDefault(); setPrepackProductToDelete(prepackProduct); setShowDeleteModal(true); }}
                                    >
                                      <span>Delete</span>
                                    </div>
                                  )}
                                </li>

                              </ul>

                            </div>
                          </td>
                        </tr>
                      )))}
                  </tbody>
                </table>

              </div>
              <div class="table-footer d-flex justify-content-between table-pagination">
                <select name="" id="" className='affter-change-cs page' value={itemsPerPage} onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1) }}>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="250">250</option>
                  <option value="500">500</option>
                </select>
                <div className=''>
                  <TableFooter
                    pageCount={pageCount}
                    handlePageClick={handlePageClick}
                    currentPage={currentPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {['edit', 'add', 'view', 'clone'].includes(methodType) && (
        <EditPrepackProduct
          formData={formData}
          productCategory={productCategory}
          setMethodType={setMethodType}
          type={methodType}
          setFormData={setFormData}
          formDataCopy={formDataCopy}
          productToEdit={productToEdit}
          setError={setError}
          originData={originData}
          touched={touched}
          setTouched={setTouched}
          fetchPrepackProducts={fetchPrepackProducts}
          setIsLoading={setIsLoading}
          errors={error}
          isLoading={isLoading}
          setSearchTerm={setSearchTerm}
          searchTerm={searchTerm}
          filterDatas={filterDatas}
          setFilterData={setFilterData}
        />
      )}
    </div>
  )
}

export default PrepackProduct